import { createMiddleware, createStart } from '@tanstack/react-start'
import { paraglideMiddleware } from '#/paraglide/server'

// Runs every request inside Paraglide's AsyncLocalStorage so getLocale()/m.*()
// resolve the visitor's locale (cookie → Accept-Language → en) during SSR.
const localeMiddleware = createMiddleware({ type: 'request' }).server(
  async ({ next, request }) => {
    let result: Awaited<ReturnType<typeof next>> | undefined
    const response = await paraglideMiddleware(request, async () => {
      result = await next()
      return result.response
    })
    if (result) return result
    return response
  },
)

export const startInstance = createStart(() => ({
  requestMiddleware: [localeMiddleware],
}))
